import Meta from 'components/Meta'
import ToastyLayout from 'components/ToastyLayout'
import { ToastySubmit } from 'components/ToastySubmit'
import { useRouter } from 'next/router'
import { requireAuth } from 'util/auth'

function Submit() {
  return (
    <>
      <Meta title="Submit" />
      <ToastyLayout current="/dashboard">
        <ToastySubmit />
      </ToastyLayout>
    </>
  )
}

export default requireAuth(Submit)
